'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import { ImageObj } from '@custom-types/ImageObj.types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ParallaxText from '@components/ParallaxText';
import ParallaxBlock from '@components/ParallaxBlock';
import ReactHtmlParser from '@libs/reactHtmlParser';
import WildsLaunchContainer from '../WildsLaunchContainer';
import SplideSlider from '@components/SplideSlider';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import cn from './style.module.scss';

interface WildsLaunchEducationProps {
  t: any;
  educationBackgroundImage: any;
  educationSlideImage: Array<ImageObj>;
  educationMobileSlideImage: Array<ImageObj>;
}
const wildsLaunchEducationSettings = {
  type: 'fade',
  rewind: true,
  autoplay: true,
  speed: 900,
  perMove: 1,
  perPage: 1,
  start: 1,
  drag: false,
  pauseOnHover: false,
};
export default function WildsLaunchEducation(props: WildsLaunchEducationProps) {
  const { t } = props;
  return (
    <Box component="section" className={cn.wildsEducationBlock}>
      <Box className={cn.wildsEducationBackground}>
        <Image
          src={props.educationBackgroundImage.url}
          alt="Wilds Launch Education - Education Background Image"
          width={768}
          height={768}
        />
      </Box>
      <WildsLaunchContainer>
        <Stack className={cn.wildsEducationInner}>
          <Box className={cn.wildsEducationSlider}>
            <Mobile>
              <SplideSlider
                options={wildsLaunchEducationSettings}
                className="orientalSlider"
              >
                {props.educationMobileSlideImage.map((image, index) => (
                  <picture key={index} className={cn.wildsEducationStory}>
                    <Image
                      src={image.url}
                      alt={`Wilds Launch Education - Education Mobile Slide Image ${index + 1}`}
                      layout="responsive"
                      width={600}
                      height={400}
                    />
                  </picture>
                ))}
              </SplideSlider>
            </Mobile>
            <Desktop>
              <SplideSlider
                options={wildsLaunchEducationSettings}
                className="orientalSlider"
              >
                {props.educationSlideImage.map((image, index) => (
                  <picture key={index} className={cn.wildsEducationStory}>
                    <Image
                      src={image.url}
                      alt={`Wilds Launch Education - Education Slide Image ${index + 1}`}
                      layout="responsive"
                      width={600}
                      height={400}
                    />
                  </picture>
                ))}
              </SplideSlider>
            </Desktop>
          </Box>
          <Box className={cn.wildsEducationContent}>
            <Box className={cn.wildsEducationContent__heading}>
              <ParallaxText
                variant="h2"
                animationType="slideInBottom"
                animationDuration={500}
              >
                <span> {ReactHtmlParser(t['schoolMainHeading'])}</span>
                <span> {ReactHtmlParser(t['schoolSubHeading'])}</span>
              </ParallaxText>
            </Box>
            <Box className={cn.wildsEducationContent__content}>
              <ParallaxText
                variant="p"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(t['schoolDesc'])}
              </ParallaxText>
            </Box>
            <Box className={cn.wildsEducationContent__list}>
              <ParallaxBlock
                animationType="slideInBottom"
                animationDuration={500}
              >
                <List className={cn.educationListInfo}>
                  {t['schoolSpecList']?.map((item: string, index: number) => (
                    <>
                      <ListItem key={index}>
                        <ListItemText>{ReactHtmlParser(item)}</ListItemText>
                      </ListItem>
                    </>
                  ))}
                </List>
              </ParallaxBlock>
            </Box>
          </Box>
        </Stack>
      </WildsLaunchContainer>
    </Box>
  );
}
